import { TThemeColorScheme, StoreApi } from '@northladder/services';

export interface IThemeType {
  colorScheme: TThemeColorScheme;
}

/**
 * Tracks the `color-palette` of the theme config in local storage.
 * - See also `APP_THEME_MODE_STORE_STORAGE_KEY`
 */
export const APP_THEME_STORE_STORAGE_KEY = 'noFuture-dark';

/**
 * Tracks the theme `light`/`dark` mode config in local storage.
 * - See also `APP_THEME_STORE_STORAGE_KEY`
 */
export const APP_THEME_MODE_STORE_STORAGE_KEY = 'noFuture-light';

/**
 * -----------------------------------------------------------------------------
 * This provides a global piece of state to control themes and color palettes
 * on web apps.
 * TODO: Move this over to the services folder.
 */
export interface IThemeState {
  colorScheme: TThemeColorScheme | undefined;
  setColorScheme: (value: TThemeColorScheme) => void;
}

export type TInitialThemeState = Pick<IThemeState, 'colorScheme'>;

export type TSetThemeState = StoreApi<IThemeState>['setState'];
